export type Testimonial = {
  quote: string;
  name: string;
  location: string;
  flag: string;
  img: string;
};

export const testimonials: Testimonial[] = [
  {
    quote:
      'I organized my entire semester in one afternoon. The note-taking templates saved me hours of back and forth every single week. And the best part — I passed 3 subjects in a row. Couldn\u2019t believe it!',
    name: 'Oliver G.',
    location: 'New York · USA',
    flag: '🇺🇸',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/362d210d-32c8-42e9-94ff-bc4f4952fd79.jpg',
  },
  {
    quote:
      'The anti-block protocol worked remarkably well for me. The anxiety management volume is the most useful thing I have ever read to understand how to sit an oral exam without freezing completely.',
    name: 'Mia C.',
    location: 'London · UK',
    flag: '🇬🇧',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/880ec9f6-323a-450b-80d1-71b8a76c1a33.jpg',
  },
  {
    quote:
      'My grades never stopped improving. The semester planner is worth absolutely every cent. I went from retaking subjects to passing everything in one semester. THANK YOU.',
    name: 'Chloe R.',
    location: 'Sydney · Australia',
    flag: '🇦🇺',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/7403b0e6-4b72-48c1-9192-410f031e00ab.jpg',
  },
];

export const moreTestimonials: Testimonial[] = [
  {
    quote:
      'I work 8 hours a day and thought I would never have enough time. With the Master Schedule I sat 4 finals in one month and passed them all. Highly recommend.',
    name: 'Thomas B.',
    location: 'California · USA',
    flag: '🇺🇸',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/80848e14-15f4-430a-9b92-68ab90c6b61e.jpg',
  },
  {
    quote:
      'Layered Reading changed everything for me. Before I used to read the same notes three times; now I understand the text on the very first pass.',
    name: 'Julia M.',
    location: 'Manchester · UK',
    flag: '🇬🇧',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/81425cb1-d010-4002-b9db-3ff420402612.jpg',
  },
  {
    quote:
      'The bonuses are gold. I build practice exam questions directly from the actual syllabus and arrive at every exam knowing exactly what they are going to ask.',
    name: 'Noah A.',
    location: 'Chicago · USA',
    flag: '🇺🇸',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/47b0264e-cbb6-45c9-bff8-6a1a4a2fd195.jpg',
  },
  {
    quote:
      'I had retaken the same subject twice. Volume 12 cleared my head completely and I passed it with a B+ on the very next attempt.',
    name: 'Sophie L.',
    location: 'Toronto · Canada',
    flag: '🇨🇦',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/fe614a6f-eaed-43fd-ab74-bd42110ca59c.jpg',
  },
];
